var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSticker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 6.667,
    height: 13.333,
    transform: "translate(3.333 3.333)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M5.667,15.667h2.5Q9,15.81,9,16.5t-.833.833H4V13.167a.737.737,0,0,1,.833-.833.737.737,0,0,1,.833.833Zm10,0v-2.5q.143-.833.833-.833t.833.833v4.167H13.167a.737.737,0,0,1-.833-.833.737.737,0,0,1,.833-.833Zm0-10h-2.5q-.833-.143-.833-.833T13.167,4h4.167V8.167A.737.737,0,0,1,16.5,9a.737.737,0,0,1-.833-.833Zm-10,0v2.5Q5.524,9,4.833,9T4,8.167V4H8.167A.737.737,0,0,1,9,4.833a.737.737,0,0,1-.833.833Z",
    transform: "translate(-0.667 -0.667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.15254625b85e8cdef831d5df6688d342.svg";
export { ForwardRef as ReactComponent };